// v2/components/CartPanel.js — header sepet acilir paneli
import React from 'react';
import { ShoppingCart, Trash2, ArrowRight, Warehouse, Tag, TrendingDown } from 'lucide-react';
import { WAREHOUSES } from '../constants/catalog';
import { formatTRY, formatNumber, formatPercent } from '../utils/format';
import styles from './CartPanel.module.css';

export default function CartPanel({
  cart, eurRate = 0, onCheckout = () => {}, onViewCart = () => {},
}) {
  const { pending, totals, remove, lineUnits } = cart;
  const eur = (v) => (eurRate > 0 ? `${formatNumber(v / eurRate, 2)} €` : null);

  return (
    <div className={styles.panel} role="dialog" aria-label="Sepetim">
      <div className={styles.head}>
        <span className={styles.headTitle}>
          <ShoppingCart size={15} /> Sepetim
        </span>
        <span className={styles.headCount}>
          {totals.itemCount} ürün / {totals.unitCount} adet
        </span>
      </div>

      {pending.length === 0 ? (
        <div className={styles.empty}>
          <span className={styles.emptyIcon}><ShoppingCart size={30} strokeWidth={1.3} /></span>
          <span className={styles.emptyTitle}>Sepetiniz boş</span>
          <span className={styles.emptyText}>Ürün ekleyerek siparişe başlayın.</span>
          <div className={styles.emptyActions}>
            <button type="button" className={styles.btnMain} onClick={onViewCart}>
              <ShoppingCart size={14} /> Sepetimi Görüntüle
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.list}>
            {pending.map((l) => {
              const units = lineUnits(l);
              const active = WAREHOUSES.filter((w) => (l.qty[w.key] || 0) > 0);
              return (
                <div key={l.key} className={styles.line}>
                  <div className={styles.lineTop}>
                    <span className={styles.lineInfo}>
                      <span className={styles.lineName} title={l.product.description}>
                        {l.product.description}
                      </span>
                      <span className={styles.lineCode}>{l.product.productCode}</span>
                    </span>
                    <span className={styles.lineQty}>{units} ad.</span>
                    <button
                      type="button" className={styles.lineDel}
                      onClick={() => remove(l.key)}
                      aria-label={`${l.product.description} kaldır`}
                    >
                      <Trash2 size={12} />
                    </button>
                  </div>

                  <div className={styles.lineMid}>
                    <span className={styles.lineWhRow}>
                      {active.map((w) => (
                        <span key={w.key} className={styles.lineWh}>
                          <Warehouse size={9} />{w.city} · {l.qty[w.key]}
                        </span>
                      ))}
                    </span>
                    <span className={styles.lineChips}>
                      {l.product.discounts.map((d, i) => (
                        <React.Fragment key={i}>
                          {i > 0 && <span className={styles.chipArrow}>›</span>}
                          <span className={`${styles.chip} ${d.kind === 'general' ? styles.chipCamp : ''}`}>
                            %{formatNumber(d.rate, 2)}
                          </span>
                        </React.Fragment>
                      ))}
                    </span>
                  </div>

                  <div className={styles.lineGrid}>
                    <span className={styles.pCell}>
                      <span className={styles.pLabel}>Brüt</span>
                      <span className={styles.pGross}>{formatTRY(l.product.grossPrice * units)}</span>
                    </span>
                    <span className={styles.pCell}>
                      <span className={styles.pLabel}>Net</span>
                      <span className={styles.pNet}>{formatTRY(l.product.netPrice * units)}</span>
                    </span>
                    <span className={styles.pCell}>
                      <span className={styles.pLabel}>KDV'li</span>
                      <span className={styles.pVat}>
                        {formatTRY(l.product.netPrice * units * (1 + (totals.vatRate || 20) / 100))}
                      </span>
                    </span>
                    <span className={styles.pGain}>
                      <TrendingDown size={11} />
                      +{formatTRY(l.product.savingAmount * units)}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          <div className={styles.summary}>
            <div className={styles.sumRow}>
              <span>Brüt Toplam</span>
              <span className={styles.sumStrike}>{formatTRY(totals.gross)}</span>
            </div>
            <div className={`${styles.sumRow} ${styles.sumDiscount}`}>
              <span><Tag size={12} /> Toplam İndirim ({formatPercent(totals.discountPct)})</span>
              <span>−{formatTRY(totals.discount)}</span>
            </div>
            <div className={styles.sumRow}>
              <span>Ara Toplam</span>
              <span>{formatTRY(totals.net)}</span>
            </div>
            <div className={styles.sumRow}>
              <span>KDV (%{totals.vatRate})</span>
              <span>{formatTRY(totals.vat)}</span>
            </div>
            <div className={styles.sumTotal}>
              <span>Genel Toplam</span>
              <span className={styles.sumTotalRight}>
                <span className={styles.sumGrand}>{formatTRY(totals.grand)}</span>
                {eurRate > 0 && <span className={styles.sumEur}>{eur(totals.grand)}</span>}
              </span>
            </div>
          </div>

          <div className={styles.actions}>
            <button type="button" className={styles.btnMain} onClick={onCheckout}>
              Siparişi Tamamla <ArrowRight size={15} />
            </button>
            <button type="button" className={styles.btnGhost} onClick={onViewCart}>
              <ShoppingCart size={14} /> Sepetimi Görüntüle
            </button>
          </div>
        </>
      )}
    </div>
  );
}
